import React, { Component } from "react";
import PropTypes from "prop-types";
import ConfirmDeclineConfirmation from "./ConfirmDeclineConfirmation";
import { Accept } from "./Accept";
import Reject from "./Reject";
import { Wrapper } from "../styles/interview-styles";

class JobOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionConfirmationActive: true,
      actionConfirmation: null,
    };
  }

  handleActionConfirmation = (action) => {
    this.setState({
      actionConfirmation: action,
      actionConfirmationActive: false,
    });
  };

  handleCancel = (e) => {
    e.preventDefault();
    const { handleCancelRecruiterConfirmation } = this.props;
    this.setState({
      actionConfirmationActive: true,
      actionConfirmation: null,
    });
    handleCancelRecruiterConfirmation(e);
  };

  render() {
    const { actionConfirmationActive, actionConfirmation } = this.state;
    const {
      cardData,
      closeActionModalAfterSubmit,
      fetchKanbanData,
      handleCancelRecruiterConfirmation,
      jobCurrencySymbol,
    } = this.props;
    const { candidate } = cardData;

    return (
      <Wrapper>
        {actionConfirmationActive && (
          <ConfirmDeclineConfirmation
            handleActionConfirmation={this.handleActionConfirmation}
            handleCancelRecruiterConfirmation={
              handleCancelRecruiterConfirmation
            }
          />
        )}
        {actionConfirmation === "accept" && (
          <Accept
            candidate={candidate}
            handleCancel={this.handleCancel}
            closeActionModalAfterSubmit={closeActionModalAfterSubmit}
            fetchKanbanData={fetchKanbanData}
            cardData={cardData}
            jobCurrencySymbol={jobCurrencySymbol}
          />
        )}
        {actionConfirmation === "reject" && (
          <Reject
            candidate={candidate}
            handleCancel={this.handleCancel}
            closeActionModalAfterSubmit={closeActionModalAfterSubmit}
            fetchKanbanData={fetchKanbanData}
            cardData={cardData}
          />
        )}
      </Wrapper>
    );
  }
}

JobOffer.propTypes = {
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
};

export default JobOffer;
